<app-dialog-sidebar>
    <div class="mobile-filter" *ngIf="(filterService.filter$ | async)?.facets as facetGroups">
        <div class="overview" *ngIf="!activeGroup" @mobileFilterAnimation>
            <ul>
                <li *ngFor="let facetGroup of facetGroups | facetGroupsWithValues; trackBy: trackFacetFn">
                    <button class="category-button kk-overflow-ellipsis" (click)="activeGroup = facetGroup">
                        {{ facetGroup.text }}
                        <span class="active-facet-names kk-overflow-ellipsis">{{
                            facetGroup.values
                                | activeFacetsNames
                                    : ', '
                                    : {
                                          '0': 'filter.facetText.no' | translateSafe,
                                          '1': 'filter.facetText.yes' | translateSafe
                                      }
                        }}</span>
                        <div class="category-icon">
                            <app-svg-icon iconName="chevron_right"></app-svg-icon>
                        </div>
                    </button>
                </li>
            </ul>
        </div>
        <div class="details" *ngIf="activeGroup" @mobileFilterAnimation>
            <ul class="list">
                <li>
                    <button class="back-button" (click)="activeGroup = null">
                        <app-svg-icon aria-hidden="true" iconName="chevron_left"></app-svg-icon>
                        {{ 'filter.mobileFilter.buttonText.back' | translateSafe }}
                    </button>
                </li>
                <li *ngFor="let facet of activeGroup.values; trackBy: trackFacetValueFn">
                    <label class="checkbox-wrapper">
                        <input
                            class="kk-checkbox kk-visuallyhidden"
                            type="checkbox"
                            [(ngModel)]="facet.selected"
                            (change)="onChange()"
                        />
                        <span class="kk-checkbox__element checkbox-element">
                            <span class="kk-checkbox__icon">
                                <app-svg-icon iconName="tick"></app-svg-icon>
                            </span>
                        </span>
                        <span class="text" [ngClass]="{ 'text-bold': facet.selected }" *ngIf="facet.key">
                            {{
                                facet.key
                                    | replaceKey
                                        : {
                                              '0': 'filter.facetText.no' | translateSafe,
                                              '1': 'filter.facetText.yes' | translateSafe
                                          }
                            }}
                            <span class="facet-count" *ngIf="facet.count"> ({{ facet.count }}) </span>
                        </span>
                    </label>
                </li>
            </ul>
        </div>
        <div class="action-buttons-container">
            <button
                class="kk-icon-btn kk-icon-btn_reverse reset-button"
                *ngIf="facetGroups | hasActiveFacets"
                (click)="reset()"
            >
                <app-svg-icon aria-hidden="true" iconName="trash"></app-svg-icon>
                {{ 'filter.buttonText.removeActiveFilters' | translateSafe }}
            </button>
            <button class="kk-btn" (click)="overlayRef.close()">
                <app-loading-dots *ngIf="filterService.pending$ | async"></app-loading-dots>
                <span *ngIf="(filterService.pending$ | async) === false">
                    {{
                        'filter.mobileFilter.buttonText.seeResults'
                            | translateSafe: { results: (filterService.filter$ | async)?.total }
                    }}
                </span>
            </button>
        </div>
    </div>
</app-dialog-sidebar>
